import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import OfferPageGoals from './OfferPageGoals';
import {
    getGoalEntries,
    getGoalActions,
    getRegions,
    getCurrRank
} from './OfferPageGoals.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    goalEntries: getGoalEntries,
    goalActions: getGoalActions,
    currRank: getCurrRank,
    regions: getRegions
});

const OfferPageGoalsComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.goalEntries.loading,
            offer: state.offers.list[0]
        };
    },
    null
)(OfferPageGoals);

export default OfferPageGoalsComponent;
